module.exports = __webpack_public_path__ + "aea4bfddca8e93157099f75ecd7f7faa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/mastercard_2021_chart.png
// module id = 1689
// module chunks = 0